module.exports = __webpack_public_path__ + "img/defaule-shop-logo-2.d6376e3e.png";